<template>
  <wh-popup
    ref="form"
    v-model="myVisible"
    :title="title"
    :ref-form="$refs.tallyBookPopup"
    :lock-scroll="false"
    @close="hidePopup"
    @open="open"
  >
    <div ref="topArcher" style="position:absolute;top:0;left: 1px;visibility: hidden;" />
    <van-form
      ref="tallyBookPopup"
      class="tally-book-popup"
      @submit="submitForm"
    >
      <div class="info-title">
        收支
      </div>
      <div class="select-btn wh-flex-start">
        <div v-for="i in btnList" :key="i.id" :class="i.text === subform.property?'btn-active':''" class="btn" @click="incomeNumFn(i)">
          {{ i.text }}
        </div>
      </div>
      <div class="info-title wh-flex-between">
        <div>收支类型</div>
        <div class="del-flag" @click="delFlag=!delFlag">
          {{ delFlag?'取消':'管理' }}
        </div>
      </div>
      <div class="count-icon-warp wh-flex-start">
        <div v-for="item in iconList" :key="item.id" class="count-icon-item" @click="checkcount(item)">
          <van-icon v-if="delFlag&&item.typeName!=='添加'" name="close" class="icon-del" @click.prevent="delTallyType(item.id)" />
          <svg-icon :icon-class="getSvg(item.typeName)" class="icon-svg" :class="item.typeName === subform.type ?'checkTag':''" />
          <div style="fontSize:12px">
            {{ item.typeName }}
          </div>
        </div>
      </div>
      <div class="info-title">
        记录时间
      </div>
      <div class="my-input-style wh-flex-between" @click="popup.timeShow = true">
        <div class="input-left">
          {{ subform.date || '选择时间' }}
        </div>
        <div class="input-right">
          <svg-icon icon-class="calendar" />
        </div>
      </div>
      <div class="info-title">
        金额(元)
      </div>
      <div class="my-input-style">
        <van-field
          v-model.number="subform.money"
          class="my-field-input"
          input-align="center"
          type="number"
        />
      </div>
      <div class="info-title">
        备注
      </div>
      <van-field
        v-model="subform.note"
        style="margin:20px 0"
        rows="2"
        autosize
        type="textarea"
        maxlength="20"
        placeholder="请输入备注信息"
        show-word-limit
      />
      <div class="info-title">
        上传图片：(最多上传三张图片)
      </div>
      <div style="padding-top:10px">
        <wh-upload v-model="subform.pic" :files-str.sync="picStr" :max-count="3" />
      </div>
    </van-form>
    <!-- 弹窗区域 -->
    <div class="add-overlay">
      <van-popup
        v-model="popup.timeShow"
        :style="{ height: '40%' }"
        position="bottom"
      >
        <van-datetime-picker
          v-model="timeCurrentDate"
          type="date"
          class="date-txt-color"
          @confirm="pickerTimeFn"
          @cancel="popup.timeShow=false"
        />
      </van-popup>
    </div>
    <van-dialog
      v-model="dialog.add.visible"
      data-name="类别名称"
      :title="dialog.add.title"
      show-cancel-button
      @confirm="submitDialog"
    >
      <div class="dialog-input">
        <van-field v-model="dialog.add.form.typeName" :clearable="true" placeholder="输入类别名称" />
      </div>
    </van-dialog>
  </wh-popup>
</template>
<script>
import api from '@/api'
import WhPopup from '@/components/public/WhPopup/WhPopup'
import { formPopup } from '@/utils/mixins/formPopup'
import { getSvg, img2String } from '@/utils/tool'
import { formatTime } from '@/utils/convert/convertTime'
import WhUpload from '@/components/public/WhUpload/WhUpload.vue'
export default {
  name: 'TallyBookPopup',
  components: { WhPopup, WhUpload },
  mixins: [formPopup],
  data() {
    return {
      delFlag: false,
      timeCurrentDate: new Date(),
      popup: {
        timeShow: false
      },
      dialog: {
        add: {
          visible: false,
          title: '类别名称',
          form: {}
        }
      },
      subform: {
        id: undefined,
        type: '',
        property: '支出',
        date: undefined,
        money: undefined,
        note: '',
        pic: []
      },
      picStr: '',
      btnList: [
        { text: '支出', id: 1 },
        { text: '收入', id: 2 }
      ],
      iconList: []
    }
  },
  computed: {
    title() {
      return this.formType === 'create' ? '记一笔' : '编辑记录'
    }
  },
  methods: {
    formatTime,
    img2String,
    getSvg,
    // 获取类型列表
    getIconList(i = '收入') {
      const params = {
        property: i
      }
      this.iconList = []
      api.getTallyType(params).then(res => {
        if (res.data) {
          this.iconList = res.data
          this.iconList.push({
            typeName: '添加',
            property: ''
          })
        } else {
          this.iconList.push({
            typeName: '添加',
            property: ''
          })
        }
      })
    },
    // 删除收支项
    delTallyType(id) {
      api.deleteTallyType({ typeId: id }).then(() => {
        this.getIconList(this.subform.property)
        this.delFlag = false
        this.$toast.success('删除成功')
      })
    },
    // 收支选择
    incomeNumFn(i) {
      this.subform.property = i.text
      this.delFlag = false
      this.getIconList(i.text)
    },
    // 点击类型
    checkcount(i) {
      if (i.typeName === '添加') {
        if (this.iconList.length < 10) {
          this.dialog.add.visible = true
          this.dialog.add.title = '类别名称'
          this.dialog.add.form.typeName = ''
        } else {
          this.$toast.fail('类别名称最多9个')
        }
      } else {
        this.subform.type = i.typeName
      }
    },
    // 添加记账本类型
    submitDialog() {
      if (!this.dialog.add.form.typeName) {
        this.$toast('请填写记账本类型')
        return
      }
      const params = {
        typeName: this.dialog.add.form.typeName,
        property: this.subform.property
      }
      api.createTallyType(params).then(() => {
        this.getIconList(this.subform.property)
        this.dialog.add.visible = false
      })
    },
    pickerTimeFn() {
      this.subform.date = this.formatTime(this.timeCurrentDate, 'YYYY-MM-DD')
      this.popup.timeShow = false
    },
    showInView() {
      this.$refs.topArcher.scrollIntoView({
        behavior: 'smooth', // 平滑过渡
        block: 'start' // 上边框与视窗顶部平齐。默认值
      })
    },
    open() {
      if (this.formType === 'create') {
        this.formDataInit(this.subform)
        this.subform.property = '收入'
        this.getIconList(this.subform.property)
      } else {
        this.formDataInit(this.subform, this.initFormData)
        this.subform.date = this.formatTime(this.subform.date, 'YYYY-MM-DD')
        this.timeCurrentDate = new Date(this.subform.date)
        this.getIconList(this.subform.property)
      }
      this.$nextTick(() => { this.showInView() })
    },
    submitForm() {
      if (!this.subform.type) {
        this.$toast('填写收支类型')
        return
      }
      if (!this.subform.date) {
        this.$toast('填写记录时间')
        return
      }
      if (!this.subform.money || this.subform.money < 0) {
        this.$toast('填写正确的金额')
        return
      }
      if (this.subform.id) {
        const editform = {
          ... this.subform,
          date: this.subform.date ? this.formatTime(this.subform.date, 'YYYY-MM-DD 00:00:00') : this.formatTime(new Date(), 'YYYY-MM-DD 00:00:00'),
          pic: this.picStr
        }
        api.updateTallyBook(editform).then(res => {
          this.submitFormSuccess()
          this.hidePopup()
        })
      } else {
        const createform = {
          ... this.subform,
          id: undefined,
          date: this.subform.date ? this.formatTime(this.subform.date, 'YYYY-MM-DD 00:00:00') : this.formatTime(new Date(), 'YYYY-MM-DD 00:00:00'),
          pic: this.picStr
        }
        api.createTallyBook(createform).then(res => {
          this.submitFormSuccess()
          this.hidePopup()
        })
      }
    }
  }
}
</script>
<style lang="less" scoped>
  /deep/ .popup-title{
    margin: 0;
    background-color: #272A3B;
    color: #fff;
    padding: 6px;
    &:after{
      border: none;
    }
  }
  /deep/.popup-title .icon{
    top: 9px;
  }
  /deep/.popup-title .text{
    font-weight: normal;
    color: #fff;
  }
.tally-book-popup{
  background-color: #f3f7f8;
  padding: 30px 20px;
  min-height: calc(100% - 150px);
  .info-title{
    padding-left: 6px;
    border-left: 2px solid #41c19e;
    font-size: 14px;
    color: #333;
    line-height: 1;
  }
  .select-btn{
    padding: 20px 0;
    .btn{
      width: 74px;
      height: 34px;
      border: 1px solid #99999999;
      border-radius: 17px;
      text-align: center;
      line-height: 34px;
      font-size: 16px;
      margin-right: 20px;
    }
    .btn-active{
       border: 1px solid #41c19e;
       background-color: #41c19e29;
       color: #41c19e;
    }
  }
  .count-icon-warp{
    padding: 24px 10px;
    align-items: start;
    flex-wrap: wrap;
    .count-icon-item{
      margin: 4px 14px;
      width: 16%;
      display: flex;
      flex-direction: column;
      align-items: center;
      position: relative;
      .icon-del{
        position: absolute;
        right: -6px;
        top: -6px;
      }
      .icon-svg{
        width: 24px;
        height: 24px;
        padding: 6px;
      }
      .checkTag{
        background-color: #ff6600;
        border-radius: 50%;
        color: #fff;
        padding: 6px;
      }
      >div{
        margin-top: 5px;
      }
    }
  }
  .my-input-style{
    margin: 30px 0;
    width: 100%;
    height: 40px;
    border-radius: 20px;
    border: 1px solid rgba(153, 153, 153, 0.6);
    padding: 0 20px;
    font-size: 14px;
    color: #999;
    .input-left{
      min-width: 200px;
      flex: 1;
      padding-left: 30px;
      text-align: center;
    }
    .input-right{
      width: 40px;
      text-align: right;
    }
    /deep/ .van-cell{
      padding: 8px 16px;
    }
    .my-field-input{
      background-color: transparent;
      font-size: 16px;
      color: #333;
      font-weight: bold;
    }
  }
}
</style>
